import React from "react";
import { Link } from "react-router-dom";

import { FiPlusCircle } from "react-icons/fi";

import Container from "../../../components/Admin/Container";
import Table, { ResponsiveTable } from "../../../components/Table";

import useReleases from "./useReleases";

function Releases() {
    useReleases();

    return (
        <Container pageTitle="Lançamentos">
            <div className="grid-add">
                <Link to="/ctop/lancamento" className="add">
                    <FiPlusCircle />
                </Link>
            </div>
            <ResponsiveTable>
                <Table id="releases-table"></Table>
            </ResponsiveTable>
        </Container>
    );
}

export default Releases;
